import FullScreenLoader from './FullScreenLoader';

export { FullScreenLoader };
export default FullScreenLoader;
